import React, { useState } from 'react';

const BusStopTable = ({ busStops, onToggle, onDelete }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [togglingId, setTogglingId] = useState(null);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDialog(true);
  };

  const confirmDelete = () => {
    onDelete(selectedId);
    setShowDialog(false);
  };

  const cancelDelete = () => {
    setShowDialog(false);
    setSelectedId(null);
  };

  const handleToggle = async (id) => {
    setTogglingId(id);
    await onToggle(id);
    setTogglingId(null);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr).toLocaleString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateStr;
    }
  };

  if (busStops.length === 0) {
    return (
      <p style={{ color: '#888', textAlign: 'center', marginTop: '20px' }}>
        No hay ubicaciones registradas.
      </p>
    );
  }

  return (
    <>
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Título</th>
            <th>Dirección</th>
            <th>Hora de llegada</th>
            <th>Activo</th>
            <th>Fecha de creación</th>
            <th>Creado por</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {busStops.map((stop) => (
            <tr key={stop.id}>
              <td>{stop.title}</td>
              <td>{stop.address || '—'}</td>
              <td>{stop.arrival_time || '—'}</td>
              <td>
                <span
                  className={`badge ${stop.is_active ? 'bg-success' : 'bg-secondary'}`}
                  style={{ fontSize: '0.85rem' }}
                >
                  {stop.is_active ? 'Sí' : 'No'}
                </span>
              </td>
              <td>{formatDate(stop.created_at)}</td>
              <td>{stop.created_by || '—'}</td>
              <td>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  {/* Toggle switch */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <div
                      onClick={() => togglingId !== stop.id && handleToggle(stop.id)}
                      style={{
                        width: '44px',
                        height: '24px',
                        borderRadius: '12px',
                        backgroundColor: stop.is_active ? '#C73B33' : '#ccc',
                        position: 'relative',
                        cursor: togglingId === stop.id ? 'wait' : 'pointer',
                        transition: 'background-color 0.2s ease',
                        flexShrink: 0,
                      }}
                      title={stop.is_active ? 'Desactivar' : 'Activar'}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: '2px',
                          left: stop.is_active ? '22px' : '2px',
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          backgroundColor: 'white',
                          transition: 'left 0.2s ease',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                        }}
                      />
                    </div>
                    <small style={{ color: '#666' }}>
                      {togglingId === stop.id ? '...' : (stop.is_active ? 'Activo' : 'Inactivo')}
                    </small>
                  </div>

                  <button
                    onClick={() => handleDeleteClick(stop.id)}
                    className="btn btn-danger btn-sm"
                  >
                    Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Delete confirmation dialog */}
      {showDialog && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h4>Estas seguro?</h4>
            <p>Una vez borrado no se puede recuperar</p>
            <div className="modal-footer">
              <button onClick={confirmDelete} className="btn btn-danger">
                OK
              </button>
              <button onClick={cancelDelete} className="btn btn-secondary">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const modalStyles = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyles = {
  backgroundColor: 'white',
  padding: '50px',
  borderRadius: '5px',
  textAlign: 'center',
};

export default BusStopTable;
